import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'list',
    standalone: true
})
export class ListPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any[] | any): string | null {
    return value && value.length ? value.join(', ') : null;
  }
}
